export const getCreateAccountPayload = state => ({
  fullName: state.createAccount.fullName,
  password: state.createAccount.password,
});
